import { setContent, setOpen } from "shared/redux/reducers/PopupSlice";
import Success from "shared/ui/Success";

export function showSuccess(dispatch: any, title: string, text: string) {
  dispatch(setOpen(true));
  dispatch(setContent(<Success text={text} title={title} />));
}
